import React, { useEffect } from 'react'
import { useState } from 'react';
import { FaMapLocationDot } from "react-icons/fa6"
import { FcStatistics } from "react-icons/fc";
import { BsFillClipboard2DataFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { FaUsers } from "react-icons/fa6";
import { FaDatabase } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { BsFillBadge3dFill } from "react-icons/bs";
import { FaRegImage } from "react-icons/fa";
import { GiMeshBall } from "react-icons/gi";
import { TfiWrite } from "react-icons/tfi";
import { IoHomeOutline } from "react-icons/io5";
import { GiSettingsKnobs } from "react-icons/gi";
import { RiSketching } from "react-icons/ri";

import {BsArrowLeftShort,BsSearch} from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { TbLogout2 } from "react-icons/tb";
import { logoutStart } from '../state/authRedux';
import { logoutSuccess } from '../state/authRedux';
import { useNavigate } from 'react-router-dom';
import { IoMenuOutline } from "react-icons/io5";


export const Navbar = ({open,setOpen,highlight}) => {
    //const [open,setOpen] = useState(true);
    const [menu,setMenu] = useState(0);
    const highlightIndex = useSelector((state)=>state.highlight.index)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logOut = () => {
        dispatch(logoutSuccess())
        navigate('/login')
        console.log('logout now')
    }

    const LinkOnClick = (index) => {
        console.log('link clicked')
    }

    const Menus = [
        {title:"Home",path:'/home',icon:<IoHomeOutline />,spacing:false},
        {title:"My Models",path:'/MyModels',icon:<BsFillBadge3dFill />,spacing:false},
        {title:"Img to 3D",path:'/Img3D',icon:<FaRegImage />,spacing:false},
        {title:"Text to Model",path:'/Text3D',icon:<TfiWrite />,spacing:false},
        {title:"Img to Mesh",path:'/ImgMesh',icon:<GiMeshBall />,spacing:false},
        {title:"Sketch to 3D",path:'/SketchTo3D',icon:<RiSketching />,spacing:false},
        
    ]

    useEffect(()=>{
    })

  return (
        <div className={`font-sans text-[14px] font-normal leading-[20px] text-gray-400 z-50 md:relative  h-screen  md:z-0 ${open?"w-[80%]":"w-[10%]"} border-r border-gray-500  
        bg-[#18181b] md:h-screen md:p-5 md:pt-8 ${open?"md:w-[20%]":"md:w-[5%]"} duration-300 ease-in-out relative`}>
            {<IoMenuOutline className={`
            ml-1 text-white text-2xl  
            absolute-right-1 top-9 cursor-pointer border border-precision ${!open && "rotate-180"} 
            `} onClick={()=>setOpen(!open)}/>}
            
            <div className='mt-2 bg-gradient-to-br from-zinc-800 to-zinc-900 rounded-md p-4 shadow-lg border border-zinc-700 cursor-pointer'>
                {<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" class="text-indigo-400 mx-auto mb-2" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path></svg>}
                <p class="text-sm font-semibold text-zinc-50 mb-1">No credits available</p>
                <p class="text-xs text-zinc-400 mb-3">Upgrade to generate with no limits and unlock all features in the Studio!</p>
                <button class="bg-indigo-600 text-white text-xs font-medium py-1.5 px-3 rounded-md shadow-md inline-flex items-center justify-center"><span class="mx-1">Unlock Now</span></button>
            </div>
            <div></div>
            <div className='pt-2 duration-300 ease-in-out h-[85%]'>
                {Menus.map((menu,index)=>
                    <Link onClick={(e)=>LinkOnClick(index)}to={menu.path} key={index} className={`h-[40px] ${index === highlightIndex?`bg-slate-500`:null} text-gray-300 cursor-pointer gap-x-4 text-sm flex p-2 items-center hover:bg-slate-500 rounded-md duration-300 ease-in-out ${menu.spacing?"mb-9":"mb-2"}`}>
                        <span className='text-md block float-left duration-300 ease-in-out'>
                            {menu.icon}
                        </span>
                        <span style={{ textOverflow: "" }} className={`whitespace-nowrap overflow-hidden text-base font-medium flex-1 duration-300 ease-in-out ${!open && "hidden"}`}>{menu.title}</span>
                    </Link>
                 
                )}
                <button onClick={()=>{console.log('settings')}} className={`h-[40px] text-gray-300 cursor-pointer gap-x-4 text-sm flex p-2 items-center duration-300 ease-in-out hover:bg-slate-500 rounded-md w-[100%]`}>
                    <span className={`text-md block float-left`}><GiSettingsKnobs/></span>
                    <span style={{ textOverflow: "" }} className={` whitespace-nowrap overflow-hidden text-base font-medium ${!open && "hidden"}`}>Settings</span>
                </button>
                <button onClick={()=>logOut()} className={` h-[40px] text-gray-300 cursor-pointer gap-x-4 text-sm flex duration-300 ease-in-out p-2 items-center hover:bg-slate-500 rounded-md w-[100%]`}>
                    <span  className={`text-md block float-left`}><TbLogout2/></span>
                    <span style={{ textOverflow: "" }} className={`whitespace-nowrap overflow-hidden text-base font-medium ${!open && "hidden"}`}>Log Out</span>
                </button>
            </div>
        </div>
    
    
  )
}